import axios from 'axios';
import { api_agyx, base_url } from '../config';


export default class AxiosService {
  constructor() {
    this.accessToken = localStorage.getItem('accessToken');
    this.refreshToken = localStorage.getItem('refreshToken');

    this.axiosInstance = axios.create({
      baseURL: api_agyx,
      headers: {
        'authorization': `Bearer ${this.accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    this.axiosInstance.interceptors.response.use(
      (value) => this.handleSuccessResponse(value),
      (error) => this.handleErrorResponse(error)
    );
  }

  handleSuccessResponse(response) {
    return response.data;
  }

  async handleErrorResponse(error) {
    if (error.response && error.response.status === 401) {
      try {
        if (!this.refreshToken) {
          throw error;
        }
        await this.getNewTokens();
        error.config.headers.authorization = `Bearer ${this.accessToken}`;
        return this.axiosInstance(error.config);
      } catch (error) {
        throw error;
      }
    } else if (error.response && error.response.status === 403) {
      this.deleteTokens();
      // window.location.href = `${base_url}`;
      throw error;
    } else {
      throw error;
    }
  }

  setTokens(accessToken, refreshToken) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }

  deleteTokens() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    this.accessToken = null;
    this.refreshToken = null;
  }

  async getNewTokens() {
    try {
      const headers = { 
        'authorization': `Bearer ${this.refreshToken}`, 
        'Content-Type': 'application/json'
      };
      const response = await this.axiosInstance.get('/auth/getNewTokens', { headers: headers });
      const { accessToken, refreshToken } = response;
      this.setTokens(accessToken, refreshToken);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async get(url, config) {
    return this.axiosInstance.get(url, config);
  }

  async post(url, data, config) {
    return this.axiosInstance.post(url, data, config);
  }

  async put(url, data, config) {
    return this.axiosInstance.put(url, data, config);
  }

  async delete(url, config) {
    return this.axiosInstance.delete(url, config);
  }
}
